/**
 *
 * Business Assistance
 *
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { injectIntl, intlShape, FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';

import PortalLayout from 'components/PortalLayout';
import bbdLogoFr from 'images/pcCarePathBapFr.png';
import bbdLogo from 'images/pcCarePathBap.png';
import { fetchUser } from '../App/actions';
import { trackUserClick } from '../EmployeeResources/actions';
import Card from './Card';
import messages from './messages';
import reducer from '../EmployeeResources/reducer';
import saga from '../EmployeeResources/saga';
import styled from 'styled-components';
import { THERAPY_URL, BBDEAP } from 'utils/environment';
import { isEap } from 'containers/Dashboard/helpers';
import PcEapLogo from 'images/pc-eap-eng-logo.png';
import PcEapLogoFr from 'images/pc-eap-fr-logo.png';

const Button = styled.button`
  border-radius: 20px;
  cursor: pointer;
  height: 40px;
  padding: 0 40px;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  outline: none;
  color: #ffffff;
  background-color: #ffffff;
  background-image: linear-gradient(to left, #e3546f, #ff6b8a);
  border: none;
`

const ButtonDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 0px 20px 0px;
  flex-direction: column;
`

// eslint-disable-next-line react/prefer-stateless-function
class BusinessAssistance extends Component {
  render() {
    const { intl, company } = this.props;
    return (
      <div>
        <Helmet>
          <title>{intl.formatMessage(messages.title)}</title>
          <meta name="description" content="Description of Health Navigation" />
        </Helmet>
        <PortalLayout activeTab="business_assistance">
          <Card>
            <FormattedHTMLMessage tagName="h1" {...messages.title} />
            <FormattedHTMLMessage tagName="h3" {...messages.subtitle} />
            <FormattedHTMLMessage tagName="p" {...messages.body1} />
            <FormattedHTMLMessage tagName="p" {...messages.body2} />
            <FormattedHTMLMessage tagName="p" {...messages.body3} />
            <FormattedHTMLMessage tagName="p" {...messages.body4} />
            <FormattedHTMLMessage tagName="p" {...messages.body5} />
            <FormattedHTMLMessage tagName="p" {...messages.body6} />
            <FormattedHTMLMessage tagName="p" {...messages.body7} />
            <ul>
              <li>
                <FormattedHTMLMessage tagName="p" {...messages.body8} />
                <FormattedHTMLMessage tagName="p" {...messages.body9} />
              </li>
              <li>
                <FormattedHTMLMessage tagName="p" {...messages.body10} />
                <FormattedHTMLMessage tagName="p" {...messages.body11} />
              </li>
            </ul>
            <FormattedHTMLMessage tagName="p" {...messages.body12} />
            <FormattedHTMLMessage tagName="p" {...messages.body13} />
            <FormattedHTMLMessage tagName="p" {...messages.body14} />
            <FormattedHTMLMessage tagName="p" {...messages.body15} />
            {isEap(company) && !BBDEAP &&
              <ButtonDiv>
                  <img
                    className="logo"
                    src={intl.locale === 'en' ? PcEapLogo : PcEapLogoFr}
                    alt="inkblot logo"
                  />
                  <a
                    href={`${THERAPY_URL}/redirect/${localStorage.getItem('token')}`}
                    target="_blank"
                    onClick={this.handleUserClick}
                  >
                    <Button>
                      <FormattedMessage {...messages.findMyCare} />
                    </Button>
                  </a>
              </ButtonDiv>
            }
            <FormattedHTMLMessage tagName="p" {...messages.body16} />
            <ul>
              <li>
                <FormattedHTMLMessage tagName="p" {...messages.body17} />
              </li>
              <li>
                <FormattedHTMLMessage tagName="p" {...messages.body18} />
              </li>
            </ul>
            <FormattedHTMLMessage tagName="p" {...messages.body19} />
            <FormattedHTMLMessage tagName="p" {...messages.body20} />
            <FormattedHTMLMessage tagName="p" {...messages.body21} />
            <FormattedHTMLMessage tagName="p" {...messages.body22} />
            {BBDEAP &&
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                  width: '100%',
                  gap: '20px',
                }}
              >
                <img
                  src={intl.locale === 'en' ? bbdLogo : bbdLogoFr}
                  alt="bbd bap logo"
                  style={{ width: '250px' }}
                />
                <a
                  href={`${THERAPY_URL}/redirect/${localStorage.getItem('token')}`}
                  target="_blank"
                  onClick={this.handleUserClick}
                >
                  <Button>
                    <FormattedMessage {...messages.findMyCare} />
                  </Button>
                </a>
              </div>
            }
          </Card>
        </PortalLayout>
      </div>
    );
  }
}

BusinessAssistance.propTypes = {
  intl: intlShape,
  trackUserClick: PropTypes.func.isRequired,
  fetchUser: PropTypes.func,
  copmany: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    trackUserClick: values => dispatch(trackUserClick(values)),
    fetchUser: callback => dispatch(fetchUser(callback)),
  };
}

function mapStateToProps(state) {
  // eslint-disable-next-line prefer-destructuring
  const company = state.toJS().app.user.data.company;
  const status = state.toJS().app.user.data.people_care;
  return { company, status };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'employee_resources', reducer });
const withSaga = injectSaga({ key: 'employee_resources', saga });

export default compose(
  withConnect,
  withReducer,
  withSaga,
)(injectIntl(BusinessAssistance));
